// 뚝딱에서 지원하는 교과목 리스트 및 순서
export const ES_SUBJECT = ['국어', '영어', '수학', '사회', '과학'] as const;
export const MS_SUBJECT = ['국어', '영어', '수학', '사회', '역사', '과학', '정보'] as const;
export const HS_SUBJECT = ['국어', '영어', '수학', '사회', '역사', '윤리','과학', '정보'] as const;

export const TTOKTTAK_CURRI_YEAR = 2; // LCMS 연동을 위한 개정 파라메터 (22개정만 지원)

export const EXCLOUD_STUDYMAP_ID: number[] = [
    58539, 58530, 59153, 59156, 59158, 59161, 59163, 59166, 59141, 59144, 59146, 59150, 58825,
    58866, 58546, 58537, 69798, 69872, 69328, 69334, 69338, 69340,
    // 초등 수학 3-2
    69249, 69242,
    // 초등 수학 4-2
    69258, 69251,
    // 초등 사회 5-1, 6-1
    80830, 80827, 80832, 80835, 80837, 80840, 80843, 80846, 80848, 80852, 80854, 80857,
    // 초등 국어 5-1, 6-1
    104405, 104446,
    // 초등 수학 5-1, 6-1
    61794, 61801, 61829, 61835, 61836, 61837, 61842, 61843, 61844, 61845, 61849, 61850, 61851,
    61859, 61858, 61857, 61860, 61867, 61868, 61869, 61878, 61879, 61880,
    // 초등 수학 6-1
    61812, 61819, 61937, 61943, 61944, 61945, 61953, 61952, 61954, 61955, 61963, 61964, 61965,
    61972, 61973, 61974, 61975, 61981, 61982, 61983, 61989, 61990, 61988,
    // 초등 수학 5-2
    61803, 61881, 61888, 61889, 61890, 61897, 61898, 61899, 61900, 61906, 61907, 61908, 61916, 61917, 61918, 61919, 61925, 61926, 61927, 61934, 61935, 61936,
    // 초등 수학 6-2
    61821, 61991, 61999, 62000, 62001, 62007, 62008, 62009, 62010, 62019, 62018, 62027, 62028, 62029, 62020, 62030, 62037, 62038, 62039, 62045, 62046, 62047,
    // 사회 5-2
    111276, 111280, 111282, 111285, 111287, 111290,
    // 사회 6-2
    111293, 111296, 111298, 111302, 111304, 111307,
    // 고등 사회와 문화
    81001, 80976, 80996,
    // 증학 역사 2
    80935,
    // 중학 수학 1
    58565,
    // 고등 정치
    111314, 111315, 111321, 111322, 111328, 111329, 111335, 111336,
    // 고등 법과 사회
    111382, 111388, 111393, 111398
];

export const EXCLOUD_EVALTYPE_ID: Record<number, number[]> = {
    // 69553: [60131, 60227],
    // 69063: [60143, 60139, 60123],
    // 69050: [60143, 60139, 60123],
    // 104376: [60138, 60127, 60131],
    // 104377: [60138, 60127, 60131],
    // 104378: [60138, 60127, 60131],
    // 104379: [60138, 60127, 60131],
    // 69557: [60227, 60140], // 중학 영어2
    // 69562: [60127, 60227], // 초등 영어5
    // 69563: [60127, 60227], // 초등 영어6
};

export const DISABLE_STUDYMAP_ID: number[] = [];
export const EXCLOUD_CURRIBOOK: number[] = [];
export const READY_CURRIBOOK: number[] = [];

export const EXCLOUD_LOGIN_ID: string[] =
    import.meta.env.VITE_DEPLOY === 'prod'
        ? [
            'testsamlc001',
            'testsamlc002',
            'testsamlc003',
            'testsamlc004',
            'testsamlc005',
            'testsamlc006',
            'testsamlc007',
            'testsamlc010',
            'testsamlc011',
            'testsamlc012',
            'testsamlc013',
            'testsamlc014',
            'testsamlc015',
            'testsamlc016',
            'testsamlc017',
            'testsamlc018',
            'testsamlc019',
            'testsamlc020',
            'testsamlc021',
            'testsamlc022',
            'testsamlc023',
            'testsamlc024',
            'testsamlc025',
            'testsamlc026',
            'testsamlc027',
            'testsamlc028',
            'testsamlc029',
            'testsamlc030',
            'aidtsam05',
            'aidtsam06',
            'aidtsam07',
            'aidtsam09',
            'aidtsam11',
            'aidtsam12',
            'aidtsam13',
            'aidtsam14',
            'aidtsam15',
            'aidtsam19',
            'aidtsam20',
            'vivatest050',
        ]
        : [
            '251testsam01',
            '251testsam02',
            '251testsam03',
            '251testsam04',
            '251testsam05',
            '251testsam06',
            '251testsam07',
            '251testsam08',
            '251testsam09',
            '251testsam10',
            'aidtsam05',
            'aidtsam06',
            'aidtsam07',
            'aidtsam09',
            'aidtsam11',
            'aidtsam12',
            'aidtsam13',
            'aidtsam14',
            'aidtsam15',
            'aidtsam19',
            'aidtsam20',
            'vivatest050',
        ];
